import { PALETTE } from '../../constants';
import { BaseControlColor } from '../../types';
import { hexToRgba, linearGradient } from '../../utils';

export const baseControlStyles = {
  [BaseControlColor.Primary]: {
    normal: {
      backgroundImage: linearGradient('#fa5400, #fa3e00'),
      backgroundColor: 'transparent',
    },
    hover: {
      backgroundImage: linearGradient('#ff681b, #ff5118'),
      backgroundColor: 'transparent',
    },
    active: {
      backgroundImage: linearGradient('#f04600, #dd3700'),
      backgroundColor: 'transparent',
    },
    disabled: {
      backgroundImage: 'none',
      backgroundColor: '#593a2d',
    },
  },
  [BaseControlColor.Secondary]: {
    normal: {
      backgroundImage: linearGradient('#4d8bff, #267cde'),
      backgroundColor: 'transparent',
    },
    hover: {
      backgroundImage: linearGradient('#529aff, #2e8af2'),
      backgroundColor: 'transparent',
    },
    active: {
      backgroundImage: linearGradient('#4885f7, #2270c9'),
      backgroundColor: 'transparent',
    },
    disabled: {
      backgroundImage: 'none',
      backgroundColor: '#2d3f59',
    },
  },
  [BaseControlColor.SystemRegular]: {
    normal: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey240,
    },
    hover: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey280,
    },
    active: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey150,
    },
    disabled: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey150,
    },
  },
  [BaseControlColor.SystemLight]: {
    normal: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey240,
    },
    hover: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey280,
    },
    active: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey150,
    },
    disabled: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey150,
    },
  },
  [BaseControlColor.Custom100]: {
    normal: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.white,
    },
    hover: {
      backgroundImage: 'none',
      backgroundColor: hexToRgba(PALETTE.white, 0.9),
    },
    active: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.white,
    },
    disabled: {
      backgroundImage: 'none',
      backgroundColor: hexToRgba(PALETTE.white, 0.7),
    },
  },
  [BaseControlColor.CustomDark]: {
    normal: {
      backgroundImage: 'none',
      backgroundColor: hexToRgba('#0d0d10', 0.6),
    },
    hover: {
      backgroundImage: 'none',
      backgroundColor: hexToRgba('#0d0d10', 0.9),
    },
    active: {
      backgroundImage: 'none',
      backgroundColor: hexToRgba('#0d0d10', 0.6),
    },
    disabled: {
      backgroundImage: 'none',
      backgroundColor: hexToRgba('#0d0d10', 0.6),
    },
  },
  [BaseControlColor.Custom300]: {
    normal: {
      backgroundImage: 'none',
      backgroundColor: 'transparent',
    },
    hover: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey280,
    },
    active: {
      backgroundImage: 'none',
      backgroundColor: PALETTE.neutrals.dark.grey150,
    },
    disabled: {
      backgroundImage: 'none',
      backgroundColor: 'transparent',
    },
  },
  [BaseControlColor.Custom400]: {
    normal: {
      backgroundImage: linearGradient('#7C4795, #5d2a7e'),
      backgroundColor: 'transparent',
    },
    hover: {
      backgroundImage: linearGradient('#8f62a4, #754991'),
      backgroundColor: PALETTE.neutrals.light.grey40,
    },
    active: {
      backgroundImage: linearGradient('#673b7c, #4e236a'),
      backgroundColor: PALETTE.neutrals.light.grey120,
    },
    disabled: {
      backgroundImage: linearGradient('#b29bbc, #a690b3'),
      backgroundColor: 'transparent',
    },
  },
  [BaseControlColor.Custom500]: {
    normal: {
      backgroundImage: linearGradient('#25B939, #239A33'),
      backgroundColor: 'transparent',
    },
    hover: {
      backgroundImage: linearGradient('#2EC943, #27AA39'),
      backgroundColor: PALETTE.neutrals.light.grey40,
    },
    active: {
      backgroundImage: linearGradient('#21A233, #20832D'),
      backgroundColor: PALETTE.neutrals.light.grey120,
    },
    disabled: {
      backgroundImage: 'none',
      backgroundColor: '#7BD587',
    },
  },
};
